import { MutationTree } from 'vuex';
import { NodeNodeLoginHistoryExcludeConditionState } from './types';
import { NodeLoginHistoryExcludeConditionItem } from '../../node_login_history_exclude_condition/types';
import * as types from './mutation-types';

export const mutations: MutationTree<NodeNodeLoginHistoryExcludeConditionState> = {
    // ノードログイン履歴収集除外条件一覧系
    [types.SEARCH_START](state) {
        const searchState = state.search;
        searchState.error = false;
        searchState.errorCode = undefined;
        searchState.errorMsg = undefined;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](
        state,
        payload: { count: number; node_login_history_exclude_conditions: Array<NodeLoginHistoryExcludeConditionItem> }
    ) {
        state.nodeLoginHistoryExcludeConditionCount = payload.count;
        state.nodeLoginHistoryExcludeConditions = payload.node_login_history_exclude_conditions;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        state.nodeLoginHistoryExcludeConditions = undefined;
        state.nodeLoginHistoryExcludeConditionCount = 0;

        state.search.isProcessing = false;
        state.search.isFetchSuccess = false;
        state.search.error = false;
        state.search.errorCode = undefined;
        state.search.errorMsg = undefined;
    },
};
